module.exports = __webpack_public_path__ + "img/calendario-grey.ec5914fc.svg";